import TopBanner from "../StylisticComponents/TopBanner";

function TermsOfService() {
    return (
        <div>
            <TopBanner>
                <h1 className="display-4 white-text hind-mysuru-bold">Terms of Service</h1>
            </TopBanner>
            <div className="container pt-5">
                <div>
                    <h1>Terms of Service — MapleMark Media Inc.</h1>
                    <b>Last updated:</b> September 30th, 2025
                </div>
                <div className="pt-3">
                    <h2>1) Who we are</h2>
                    <div>
                        MapleMark Media Inc. (“MapleMark,” “we,” “us,” or “our”) provides a social-media tool that helps users create, schedule, publish, and analyze content across supported platforms (the “Service”).
                    </div>
                </div>
                <div className="pt-3">
                    <h2>2) Agreement to these Terms</h2>
                    <div>
                        By creating an account, accessing, or using the Service, you agree to these Terms of Service (“Terms”) and our Privacy Policy. If you are using the Service on behalf of an organization, you represent that you have authority to bind that organization to these Terms.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>3) Eligibility</h2>
                    <div>
                        You must be at least 13 years old (or the age of digital consent in your jurisdiction, if higher). If you are under 18, you must have parental or guardian consent.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>4) Your Account</h2>
                    <div>
                        You’re responsible for (a) the information you provide, (b) maintaining the security of your account and credentials, and (c) all activity under your account. Notify us immediately of any unauthorized use.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>5) Acceptable Use</h2>
                    <div>
                        You agree not to:<br></br>
&bull; Break the law or others’ rights (including IP, privacy, or publicity rights).<br></br>


&bull; Post or transmit content that is illegal, deceptive, harmful, hateful, or harassing.<br></br>


&bull; Attempt to access the Service by automated means not provided by us, or interfere with the Service’s operation or security.<br></br>


&bull; Use the Service to spam or to circumvent platform rules of third-party social networks.
 We may investigate violations and suspend or terminate accounts at our discretion.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>6) Your Content</h2>
                    <div>
                        You retain ownership of content you submit to or publish through the Service (“User Content”). You grant MapleMark a worldwide, non-exclusive, royalty-free license to host, store, transmit, display, and otherwise process User Content solely to operate and improve the Service and to provide support. You are responsible for obtaining rights and permissions for any third-party content you use.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>7) Third-Party Platforms & Integrations</h2>
                    <div>
                        The Service may connect to third-party social networks and tools. Those services are governed by their own terms and policies; you are responsible for complying with them. We are not responsible for third-party services and do not control their availability or performance.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>8) Plans, Fees, and Billing</h2>
                    <div>
                        Some features may require a paid subscription. Fees, plan limits, and included features are described at the point of purchase. All fees are non-refundable. Taxes may apply. Subscriptions renew automatically unless canceled before the renewal date.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>9) Cancellations & Refunds</h2>
                    <div>
                        You may cancel at any time, effective at the end of your current billing period. Refunds are not provided.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>10) Service Changes & Availability</h2>
                    <div>
                        We may modify or discontinue features with notice where practicable. We aim for high availability but do not guarantee uptime. Planned outages and emergencies may occur.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>11) Intellectual Property</h2>
                    <div>
                        The Service, including software, trademarks, and content we provide, is owned by MapleMark and its licensors and is protected by law. No rights are granted except as stated in these Terms.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>12) Feedback</h2>
                    <div>
                        If you provide feedback or suggestions, you grant us a perpetual, worldwide, royalty-free license to use them without restriction.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>13) Confidentiality</h2>
                    <div>
                        We will treat your non-public information as confidential and use it only to provide the Service, except where disclosure is required by law.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>14) Disclaimers</h2>
                    <div>
                        THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE.” TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>15) Limitation of Liability</h2>
                    <div>
                        TO THE MAXIMUM EXTENT PERMITTED BY LAW, MAPLEMARK AND ITS AFFILIATES WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR USE. OUR TOTAL LIABILITY FOR ANY CLAIM RELATING TO THE SERVICE WILL NOT EXCEED THE AMOUNT YOU PAID US IN THE 12 MONTHS BEFORE THE EVENT GIVING RISE TO THE CLAIM.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>16) Indemnity</h2>
                    <div>
                        You will indemnify and hold MapleMark harmless from claims, damages, and costs (including legal fees) arising from your misuse of the Service, your User Content, or your violation of these Terms or applicable law.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>17) Suspension & Termination</h2>
                    <div>
                        We may suspend or terminate your access if you breach these Terms, pose a security or legal risk, or to protect the Service. You may terminate by canceling your subscription and ceasing use. Sections that by their nature should survive (e.g., IP, disclaimers, limitations of liability, indemnity, governing law) will survive termination.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>18) Governing Law & Dispute Resolution</h2>
                    <div>
                        These Terms are governed by the laws of Ontario and Canada, without regard to conflicts of law rules. Disputes will be resolved by the courts of ONTARIO. Either party may seek injunctive relief in court. Small-claims actions may proceed in court.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>19) Export & Sanctions</h2>
                    <div>
                        You represent you are not barred by applicable export controls or sanctions and will not use the Service in prohibited jurisdictions or for prohibited purposes.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>20) Changes to These Terms</h2>
                    <div>
                        We may update these Terms. We’ll post the new date above and, if changes are material, provide reasonable notice. Your continued use after changes take effect constitutes acceptance.
                    </div>
                </div>
                <div className="pt-3">
                    <h2>21) Contact</h2>
                    <div>
                        MapleMark Media Inc.<br></br>
Address: 4226 Duke of York Blvd, Mississauga, ON L5B 4C1<br></br>
Email: info@maplemarkmedia.com
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default TermsOfService;